<template>
  <li class="file">
    <div class="top-row">
      <quantity
        :editable="false"
        :quantity="file.quantity"
        @setQuantity="setQuantity"
        class="quantity"
      ></quantity>

      <!--   <div class="product">
        <h4>Product:</h4>
        <span>{{ file.productSpecs.title }}</span>
      </div> -->
      <div class="name">
        <span class="title">Bestand:</span>
        <span>{{ file.fileName }}</span>
        <!--         <span v-if="requiredSpecsMissing && !hideErrors" class="required-indicator error-text">Verplicht veld ontbreekt</span> -->
      </div>

      <div class="button">
        <button @click="toggleInfo" v-if="hasProduct">
          <span>Eigenschappen</span>
          <svg
            :class="{ open: showInfo }"
            class="triangle"
            xmlns="http://www.w3.org/2000/svg"
            width="7"
            height="9"
            viewBox="0 0 7 9"
          >
            <path
              fill="#4f4f4f"
              fill-rule="evenodd"
              d="M53.350798,8.37748247 L55.8813132,12.4745071 C56.1715349,12.9443899 56.0258909,13.5605763 55.5560081,13.850798 C55.3980857,13.9483383 55.216132,14 55.0305152,14 L49.9694848,14 C49.4172,14 48.9694848,13.5522847 48.9694848,13 C48.9694848,12.8143832 49.0211465,12.6324295 49.1186868,12.4745071 L51.649202,8.37748247 C51.9394237,7.90759971 52.5556101,7.76195565 53.0254929,8.05217736 C53.1577361,8.13385698 53.2691184,8.24523927 53.350798,8.37748247 Z"
              transform="rotate(-90 25 32)"
            />
          </svg>
        </button>
        <button v-else-if="!hideErrors" @click="$emit('no-product')">
          <span class="error-text">
            Geen printeigenschappen gekozen, klik hier.
          </span>
        </button>
      </div>

      <div class="price" v-if="noPriceAvailable && hasProduct">
        <span>Geen prijscalculatie mogelijk</span>
      </div>
      <div class="price" v-else-if="showPrice && hasProduct">
        <h4 v-if="file.status === 'READY'">Prijs</h4>
        <span class="">{{ filePrice }}</span>
      </div>

      <button
        class="remove-file"
        @click.stop="removeFile(file)"
        v-if="deleteable"
      >
        <svg class="trash" width="15px" height="15px" viewBox="0 0 15 15">
          <title>Verwijderen</title>
          <g id="prullenmand">
            <path
              fill="#4f4f4f"
              d="M3,4 L3,13.25 C3,13.6642136 3.3581722,14 3.8,14 L10.2,14 C10.6418278,14 11,13.6642136 11,13.25 L11,4 L3,4 Z M9,2 L13,2 L13,3 L12,3 L12,13.4285714 C12,14.2964475 11.2538079,15 10.3333333,15 L3.66666667,15 C2.74619208,15 2,14.2964475 2,13.4285714 L2,3 L1,3 L1,2 L5,2 L5,1 C5,0.44771525 5.44771525,1.01453063e-16 6,0 L8,0 C8.55228475,-1.01453063e-16 9,0.44771525 9,1 L9,2 Z M5,6 L5,12 L6,12 L6,6 L5,6 Z M8,6 L8,12 L9,12 L9,6 L8,6 Z"
            ></path>
          </g>
        </svg>
      </button>
    </div>
    <transition-height
      :class="{ 'specs-info-l': editable, 'specs-info-s': !editable }"
    >
      <file-info
        v-show="file.productSpecs.title && showInfo"
        class="specs"
        :class="{ open: showInfo }"
        :product="file.productSpecs.specs"
        :file="file"
        :editable="editable"
      >
      </file-info>
    </transition-height>
  </li>
</template>

<script>
import FileInfo from '@/features/checkOut/children/FileInfo.vue'
import Quantity from '@/components/ui/ProductQuantity.vue'
import TransitionHeight from '@/components/TransitionHeight.vue'
import { mapStores } from 'pinia'
import { useCheckOutStore } from '@/features/checkOut/CheckOut.store'
import { useProductOrderStore } from '@/features/productOrder/ProductOrder.store'

export default {
  components: { FileInfo, Quantity, TransitionHeight },
  props: ['file', 'editable', 'open', 'deleteable', 'hideErrors', 'viewOnly'],
  data() {
    return {
      showInfo: this.open || this.viewOnly
    }
  },
  computed: {
    ...mapStores(useCheckOutStore),
    filePrice() {
      /*  if (!this.file.productSpecs.title) {
        return ''
      } else if (
        this.file.status === 'READY_NOT_ANALYZED' ||
        this.file.status === 'READY_PASSWORD_PROTECTED' ||
        this.file.price === 'NA'
      ) {
        return 'Geen prijscalculatie mogelijk'
      } */
      let full = this.file.quantity * this.file.price

      full = full.toFixed(2).replace('.', ',')
      return '€ ' + full
    },
    noPriceAvailable() {
      if (
        this.file.status === 'READY_NOT_ANALYZED' ||
        this.file.status === 'READY_PASSWORD_PROTECTED' ||
        this.file.price === 'NA'
      ) {
        return true
      } else {
        return false
      }
    },
    showPrice() {
      return this.rootStore.theme.customFields.productOrder?.calculatePrice
    },
    hasProduct() {
      return this.file.productSpecs.title && this.file.productSpecs.specs
    },
    requiredSpecsMissing() {
      const specs = this.file.productSpecs?.specs
      if (!specs?.length) return false
      const product = useProductOrderStore().products?.find(
        (p) => p.title === this.file.productSpecs?.title
      )
      if (!product) return false
      for (const menu of product.menus) {
        for (const og of menu.optionGroups || []) {
          if (!og.required) continue
          const spec = specs.find((s) => s.optionGroupName === og.name)
          if (!spec || !spec.optionTitle) return true
        }
      }
      return false
    }
  },
  methods: {
    toggleInfo() {
      if (this.file.productSpecs.title) {
        this.showInfo = !this.showInfo
      } else {
        this.$emit('no-product')
      }
    },
    setQuantity(val) {
      this.checkOutStore.updateQuantity([[this.file.fileName], val])
    },
    removeFile(file) {
      this.$emit('remove', file.uuid)

      this.checkOutStore.removeFile(file.uuid)
    }
  }
}
</script>

<style lang="scss" scoped>
.file {
  box-shadow: var(--default-shadow);
  //min-height: 52px;
  border-radius: 32px;
  padding: 0 25px;
  margin-bottom: 20px;
  cursor: pointer;
}

.quantity {
  container-type: normal;
  padding-right: 20px;
}

.top-row {
  display: flex;
  min-height: 65px;
  align-items: center;
  padding: 10px 0;
  flex-wrap: wrap;
  position: relative;
  h4 {
    font-weight: 600;
    display: inline-block;
    padding-right: 10px;
  }

  > div {
    padding-right: 20px;
    padding-bottom: 10px;

    &:last-child {
      padding-right: 0;
    }
  }

  .name {
    flex: 100% 1 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    .title {
      font-weight: 600;
      padding-right: 10px;
    }

    .required-indicator {
      margin-left: 8px;
      font-size: 0.75rem;
      font-weight: 600;
    }
  }

  .remove-file {
    position: absolute;
    top: 23px;
    right: 0;
  }

  .price {
    margin-left: auto;
  }

  .button {
    button {
      font-size: 14px;
      font-weight: 500;
      color: #4f4f4f;

      span {
        padding-right: 5px;
      }
    }
  }
}

.trash {
  &:hover {
    path {
      transition: fill 0.4s;
      fill: #fd514d;
    }
  }
}

.triangle {
  transform-origin: 5px 4px;
  transition: transform 0.35s;

  &.open {
    transform: rotate(-90deg);
  }
}

@media only screen and (min-width: 768px) {
  .top-row {
    > div {
      padding-bottom: 0;
    }
    .remove-file {
      position: static;
    }

    .name {
      flex: 280px 1 1;
    }
  }
}
</style>
